import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewsComponent } from './reviews/reviews.component';
import { NgbProgressbarModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { MakereviewComponent } from './makereview/makereview.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { ReactiveFormsModule } from '@angular/forms';




@NgModule({
  declarations: [
    ReviewsComponent,
    MakereviewComponent
  ],
  imports: [
    CommonModule,
    NgbRatingModule,
    NgbProgressbarModule,
    TextFieldModule,
    ReactiveFormsModule
  ]
})
export class ReviewsModule { }
